import { render, staticRenderFns } from "./TenantOwnTermsOfService.vue?vue&type=template&id=d8dbd020&"
import script from "./TenantOwnTermsOfService.vue?vue&type=script&lang=ts&"
export * from "./TenantOwnTermsOfService.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
